import {
    apiRequest,
    riwayatsumpahDetail,
    riwayatsumpahApprove,
    masterRegion
} from "../../../../../services/adapters/kepegawaian/riwayatsumpahService"

class ApproveRepository {

    fetchRegionCountry = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionProvince = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchRegionCity = async (query) => {
        return await apiRequest("get", masterRegion, {
            params: query
        }, true)
    }

    fetchDetail = async (query) => {
        return await apiRequest("get", riwayatsumpahDetail, {
            params: query
        }, true)
    }

    fetchApprove = async (query) => {
        return await apiRequest("post", riwayatsumpahApprove, {
            body: query
        }, true)
    }
}

export default ApproveRepository